<template>
  <div 
    :class="[
      'px-8 py-8 flex items-center justify-between transition-all duration-300',
      isHomePage 
        ? 'bg-gradient-to-r from-dark-800 via-dark-800/95 to-dark-800 border-l-4 border-l-emerald-500/35' 
        : 'bg-dark-800 border-dark-600'
    ]"
  >
    <!-- 홈 화면일 때: 하나은행 로고와 ON 표시 -->
    <template v-if="isHomePage">
      <div class="flex items-center -ml-4">
        <span class="text-xl font-bold text-white ml-4">FundRiskLab</span>
      </div>
      <div class="flex items-center">
        <span class="text-green-500/50 font-bold text-base px-5 py-[0.3rem] border-2 border-green-500/50 rounded-md animate-pulse bg-emerald-900 bg-opacity-30">
          <i class="bi bi-play-fill text-green-500"></i>
          ON
        </span>
      </div>
    </template>
    <!-- 다른 페이지일 때: 기본 표시 -->
    <div v-else class="flex items-center gap-4">
      <h2 class="text-heading-2">{{ pageTitle }}</h2>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const pageTitle = computed(() => {
  return route.meta.title || '';
});

const isHomePage = computed(() => {
  return route.name === 'Home';
});
</script>

<style scoped>
</style>
